import { showReturnNotification } from "./dashboard_utils";
export function setupNotificationToggle() {
    const notificationsSwitch = document.getHtmlElementById("notificationsSwitch");
    const notificationStatus = document.getHtmlElementById("notificationStatus");
    const notificationBadge = document.querySelector('a[href="#Notifications"] .badge');
    if (notificationsSwitch && notificationStatus && notificationBadge) {
        // When the switch is toggled
        notificationsSwitch.addEventListener("change", async function () {
            try {
                await setNotificationStatus(this.checked);
                if (this.checked) {
                    showReturnNotification("success", "Notifications enabled successfully.");
                    notificationStatus.textContent = "On";
                    notificationStatus.classList.remove("text-danger");
                    notificationStatus.classList.add("text-success");
                    notificationBadge.textContent = "On";
                    notificationBadge.classList.remove("bg-danger");
                    notificationBadge.classList.add("bg-success");
                }
                else {
                    showReturnNotification("success", "Notifications disabled successfully.");
                    notificationStatus.textContent = "Off";
                    notificationStatus.classList.remove("text-success");
                    notificationStatus.classList.add("text-danger");
                    notificationBadge.textContent = "Off";
                    notificationBadge.classList.remove("bg-success");
                    notificationBadge.classList.add("bg-danger");
                }
            }
            catch (error) {
                if (error instanceof Error) {
                    showReturnNotification("danger", error.message);
                }
                else {
                    showReturnNotification("danger", "Failed to update notification status.");
                }
                // Revert the switch state
                this.checked = !this.checked;
            }
        });
    }
}
async function setNotificationStatus(enabled) {
    const response = await (enabled ? fetch("NotifyMe/EnableNotifications", { method: "POST" }) : fetch("NotifyMe/DisableNotifications", { method: "POST" }));
    if (!response.ok) {
        throw new Error(`Failed to update notification status: ${response.status} - ${response.statusText}`);
    }
}
